// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1XjeM","footer":"ModalInfo_footer___At97"};